export const ETAB_LAYOUTS = {
  dashboard: "DashboardLayout",
  default: "NoLayout",
  no: "NoLayout",
  pricing: "PricingLayout",
  routing: "RoutingLayout",
  startup: "StartupLayout",
  steps: "StepsLayout",
  success: "SuccessLayout",
};

export const ETAB_DASHBOARD_DRAWER = {
  shift: "ShiftDrawer",
};
